import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteRole(uuid: string): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/iam/role/${uuid}`)
}
